export default "__VITE_ASSET__Dwf9aCcA__"